import React from "react";
import { ReactComponent as CheckIcon } from '../../../../../../assets/icons/check_purple_icon.svg'

const ActionList = (props) =>{
    return(
        <div className="popover-container">
            { <div className="popover-item" onClick={()=>{props.setEditOpen(true); props.open(false)}}>Edit<CheckIcon className="check"/></div> }
            {/* { <div className="popover-item" onClick={()=>{props.setDeleteOpen(true); props.open(false)}}>Delete<CheckIcon className="check"/></div> } */}
        </div>
    )
}

export default ActionList;